import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData } from '../../types';
import { ShareOwnerInfoApi } from '../../apis/share-owner-info-api';
import type { ShareOwnerInfoRepository } from '../../services/share-tools-repository';

@injectable()
export class ShareOwnerInfoRepositoryImpl implements ShareOwnerInfoRepository {
    constructor(
        @inject(ShareOwnerInfoApi) private shareOwnerInfoApi: ShareOwnerInfoApi
    ) {
    }

    getShareOwnerInfo(data: ShareAuthCheckData) {
        return this.shareOwnerInfoApi.getShareOwnerInfo(data).then(res => {
            return {
                ownerName: res.owner_name,
                ownerId: res.owner_id,
            }
        });
    }
}
